import React, { useState } from 'react';
import shufflrLogo from '../assets/shufflr-logo-stacked.svg';
import {
      landingPageStyle,
      landingHeroStyle,
      landingTagWrapStyle,
      landingHeadlineStyle,
      landingSubStyle,
      landingCtaRowStyle,
      landingCtaBtnStyle,
      landingDemoLinkStyle,
      landingDividerStyle,
      landingFeaturesStyle,
      landingFeatureCardStyle,
      landingFeatureIconStyle,
      landingFeatureTitleStyle,
      landingFeatureTextStyle,
      landingQuoteStyle,
      landingFooterStyle,
} from '../App.styles';

const FEATURES: Array<{ icon: React.ReactNode; title: string; text: string }> = [
    {
            icon: '📅',
            title: 'Schedule in minutes',
            text: 'Build a full season schedule, assign courts, and set match times without spreadsheets.',
    },
    {
            icon: (
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="16" cy="16" r="15" fill="#F5C842"/>
                              <circle cx="16" cy="16" r="10" fill="#D4A017"/>
                              <circle cx="16" cy="16" r="5" fill="#FFF8F0"/>
                              <circle cx="16" cy="16" r="2" fill="#F5C842"/>
                      </svg>
                    ),
            title: 'Live scores',
            text: 'Players submit scores from their phones. Standings update automatically after every match.',
    },
    {
            icon: '🏆',
            title: 'Season standings',
            text: 'Wins, losses, point differentials — everything your club needs to crown a champion.',
    },
    {
            icon: '🎨',
            title: 'Your club, your brand',
            text: 'Custom colours, logo, and team names. Shufflr looks like your club, not generic software.',
    },
    {
            icon: (
                      <img
                                  src="https://allenshuffleboard.com/cdn/shop/files/2075_-_Telescoping_Cue_Blue_-_Collapsed_180x.jpg?v=1737404196"
                                  alt="Shuffleboard cue"
                                  width={48}
                                  height={48}
                                  style={{ objectFit: 'contain', borderRadius: 8, transform: 'rotate(180deg)' }}
                                />
                    ),
            title: 'Shuffleboard 101',
            text: 'New to the sport? Learn the rules, scoring, and strategy — everything you need to get sliding.',
    },
    {
            icon: '🛍️',
            title: 'Merch & store',
            text: 'Shop cues, pucks, wax, and club gear. Everything you need on and off the court, in one place.',
    },
    ];

export function LandingPage(): React.JSX.Element {
      const [email, setEmail] = useState('');
      const [submitted, setSubmitted] = useState(false);
    
      function handleSubmit(e: React.FormEvent): void {
              e.preventDefault();
              if (!email.trim()) return;
              // In a real integration this would POST to a mailing list endpoint.
              setSubmitted(true);
      }
    
      return (
              <div style={landingPageStyle}>
              
                  {/* ── Hero ── */}
                    <section style={landingHeroStyle}>
                            <div style={landingTagWrapStyle}>
                                      <img
                                                      src={shufflrLogo}
                                                      alt="Shufflr"
                                                      style={{ width: 260, height: 'auto', display: 'block' }}
                                                    />
                            </div>
                    
                            <div>
                                      <h1 style={landingHeadlineStyle}>League management<br />for shuffleboard clubs.</h1>
                                      <p style={landingSubStyle}>
                                                  Schedules, scores, and standings — all in one place. Built for the clubs that play Thursday nights, drink cold ones after, and deserve better than a spreadsheet.
                                      </p>
                            
                                      <div style={landingCtaRowStyle}>
                                          {submitted ? (
                                <p style={{ color: '#4BAD8F', fontWeight: 700, fontSize: '1.05rem' }}>
                                                ✓ You're on the list — we'll be in touch!
                                </p>
                              ) : (
                                <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
                                                <input
                                                                      type="email"
                                                                      value={email}
                                                                      onChange={e => setEmail(e.target.value)}
                                                                      placeholder="your@email.com"
                                                                      required
                                                                      style={{
                                                                                              padding: '0.65rem 1rem',
                                                                                              borderRadius: 8,
                                                                                              border: '2px solid rgba(232,80,122,0.3)',
                                                                                              fontFamily: 'var(--font-body)',
                                                                                              fontSize: '0.95rem',
                                                                                              outline: 'none',
                                                                                              background: '#fff',
                                                                                              color: '#2D2015',
                                                                                              minWidth: 220,
                                                                      }}
                                                                    />
                                                <button type="submit" style={landingCtaBtnStyle}>
                                                                  Request early access →
                                                </button>
                                </form>
                                                  )}
                                      </div>
                            
                                      <a href="/org/palmbreeze" style={landingDemoLinkStyle}>
                                                  See a live demo club ↗
                                      </a>
                            </div>
                    </section>
              
                  {/* ── Divider ── */}
                    <div style={landingDividerStyle} />
              
                  {/* ── Features ── */}
                    <section style={landingFeaturesStyle}>
                            <h2 style={{
                            fontFamily: 'var(--font-heading)',
                            fontSize: '1.6rem',
                            color: '#2D2015',
                            textAlign: 'center',
                            marginBottom: '2.5rem',
                            fontWeight: 800,
              }}>
                                      Everything your club needs
                            </h2>
                    
                            <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                            gap: '1.25rem',
              }}>
                                {FEATURES.map(f => (
                              <div key={f.title} style={landingFeatureCardStyle}>
                                            <span style={landingFeatureIconStyle}>{f.icon}</span>
                                            <h3 style={landingFeatureTitleStyle}>{f.title}</h3>
                                            <p style={landingFeatureTextStyle}>{f.text}</p>
                              </div>
                            ))}
                            </div>
                    </section>
              
                  {/* ── Quote ── */}
                    <blockquote style={landingQuoteStyle}>
                            "Good times, good people, even better scores."
                    </blockquote>
              
                  {/* ── Footer ── */}
                    <footer style={landingFooterStyle}>
                            <span style={{ fontFamily: 'var(--font-accent,"Pacifico",cursive)', fontSize: '1.2rem', color: '#E8507A' }}>Shufflr</span>
                            <span style={{ opacity: 0.5, fontSize: '0.8rem' }}>· League management for shuffleboard clubs · shufflr.cloud</span>
                    </footer>
              </div>
            );
}
